var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinibus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 27,
    viewBox: "0 0 68 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06655 23.3727H6.06652C3.96954 23.2314 0.83433 23.0201 0.422239 22.3505C-0.177761 21.3755 0.872279 13.6505 2.29728 12.7505C3.01128 12.2995 4.53492 11.9427 6.01912 11.5952C7.49709 11.2491 8.93595 10.9121 9.49727 10.5005C10.2778 9.92806 12.0596 8.25464 13.6537 6.75754L13.6537 6.75754L13.6537 6.7575C14.3571 6.09695 15.0239 5.47072 15.5519 4.98854C15.7166 4.83817 15.8882 4.67959 16.0658 4.51535L16.0663 4.51496L16.0663 4.51491L16.0663 4.51491C17.7493 2.959 19.9813 0.895542 22.1519 0.488545C24.5519 0.0385447 60.9269 -0.336455 63.1019 0.488545C64.6137 1.06198 65.4952 5.8756 66.094 9.14524L66.0942 9.14642L66.0952 9.1518C66.1851 9.64287 66.2686 10.099 66.347 10.5005C66.947 13.5755 66.872 16.8005 66.872 16.8005L67.322 19.8005L67.8031 21.2539C68.1159 22.199 67.4382 23.1811 66.4435 23.2239L61.4519 23.4385H61.3045C61.4 23.0163 61.4504 22.577 61.4504 22.1259C61.4504 18.8536 58.7977 16.2009 55.5254 16.2009C52.2531 16.2009 49.6004 18.8536 49.6004 22.1259C49.6004 22.577 49.6508 23.0163 49.7463 23.4385H49.6019H17.9534C18.0489 23.0163 18.0993 22.577 18.0993 22.1259C18.0993 18.8536 15.4466 16.2009 12.1743 16.2009C8.902 16.2009 6.24929 18.8536 6.24929 22.1259C6.24929 22.5612 6.29624 22.9856 6.38536 23.3942L6.06655 23.3727ZM13.9018 9.33868C16.2518 7.18868 21.3268 2.76868 22.8268 2.28868C24.7018 1.68868 29.8768 1.83868 29.8768 1.83868V9.33868H13.9018ZM32.5026 1.91398V8.96398H47.5776V1.91398H32.5026ZM49.9013 8.58854V2.06354H60.7013C61.4513 3.38854 62.7713 6.66854 62.0513 8.58854H49.9013Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1742,
    cy: 22.1251,
    r: 3.75,
    stroke: "#BABABA",
    strokeWidth: 1.95
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.6,
    cy: 22.1251,
    r: 3.75,
    stroke: "#BABABA",
    strokeWidth: 1.95
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinibus);
export default ForwardRef;